<template>
  <div class="label-container">
    <!-- <div class="tab-blank"></div> -->
    <!-- 标签栏 -->
    <div class="label-list" v-if="labelList.length">
      <div
        class="label-item"
        :class="{ 'label-item-focus': item.tagId == tagId }"
        v-for="(item, index) in labelList"
        :key="index"
        @click="labelFilterRemarkList(item)"
      >
        <span class="label-name" :class="{ 'fs-32': item.tagName.length > 4 }" v-text="item.tagName"></span>
        <span class="label-num" v-text="formatCount(item.evaluateNum) || 0"></span>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { formatCount } from '@/utils/common'
import { mapGetters } from 'vuex'
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    labels: {
      type: Array,
      default: () => {
        return []
      }
    },
    tagId: {
      type: [Number, String]
    }
  },
  data() {
    //这里存放数据
    return {}
  },
  //监听属性 类似于data概念
  computed: {
    ...mapGetters('detailv3', ['spuId', 'skuId']),
    labelList() {
      return this.labels.filter(el => {
        return el.evaluateNum
      })
    }
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    formatCount,
    labelFilterRemarkList(item) {
      this.$track({
        cfrom: '105|004|01|077',
        event_id: '105|004|01|077',
        tag_content: item.tagName,
        sku_id: this.skuId,
        spu_id: this.spuId
      })
      this.$emit('labelFilterRemarkList', item.tagId, item.tagName)
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped src="./index.scss">
//@import url(); 引入公共css类
</style>
<style lang="scss" scoped>
.vivo-fontscale-5 {
  .label-list .label-item .label-name {
    font-size: 32px;
  }
  .label-list .label-item .fs-32 {
    font-size: 26px;
  }
}
</style>
